import {
  Tabs,
  CapsuleTabs,
  SpinLoading,
  List,
  InfiniteScroll,
} from "antd-mobile";
import styled from "styled-components";
import Product from "./Product";
import "./index.css";
import { useEffect, useState } from "preact/hooks";
import request from "../base/request";
import ProductItem from "../subsidy/ProductItem";
import _, { isArray } from "lodash";
import SearchBar from "./Search";
import QueryProduct from "./QueryProduct";
import QueryBase from "./QueryBase";

const DOMAIN = `https://secret-list.io.mlj130.com/lt/live-theme`;

import Loading from "./Loading";
import Base from "./Base";

const Index = () => {
  const [category, setCategory] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);

  const [activeKey, setActiveKey] = useState("today");

  const [promotion, setPromotion] = useState(null);
  const [img, setImg] = useState("");
  useEffect(async () => {
    document.title = "主题页";

    if (category[currentTab] && category[currentTab].list.length > 0) return;
    const params = new URLSearchParams();
    if (currentTab === 0) {
      params.set("category", "全部");
    } else params.set("category", category[currentTab].name);

    const { data, err } = await request(
      DOMAIN + "/history-list?" + params.toString(),
      { method: "GET" }
    );
    if (err) return;
    if (category.length === 0) {
      setCategory(
        data.data.category.map((i, index) => ({
          name: i,
          list: index === currentTab ? data.data.list : [],
          index,
          hasMore: data.data.hasMore,
        }))
      );
      return;
    }
    category[currentTab].list = _.concat(
      category[currentTab].list,
      data.data.list
    );
    setCategory(_.cloneDeep(category));
  }, [currentTab]);

  useEffect(async () => {
    const search = new URLSearchParams(window.location.search);
    if (search.has("tab")) {
      if (search.get("tab") === "0") setActiveKey("today");
      if (search.get("tab") === "1") setActiveKey("promotion");
      if (search.get("tab") === "2") setActiveKey("query");
    }
    const { data, err } = await request(DOMAIN + "/config", { method: "GET" });
    if (err) return;
    console.log(data);
    if (isArray(data.data.banner) && data.data.banner.length > 0) {
      setImg(data?.data?.banner[0].image);
    }
    setPromotion(data.data?.promotion);
  }, []);

  console.log(promotion);
  return (
    <Container>
      {img && <Img src={img} />}
      <Sticky>
        <Tabs
          style={{
            "--fixed-active-line-width": "8px",
            "--active-line-height": "3px",
          }}
          onChange={setActiveKey}
          activeKey={activeKey}
        >
          <Tabs.Tab title="今晚直播" key="today">
            <Base url="today-list" />
          </Tabs.Tab>
          {/* <Tabs.Tab title='历史直播' key='history'>
                        <SearchBar />

                        <CapsuleTabs defaultActiveKey={`${currentTab}`} onChange={setCurrentTab}>
                            {category.map((i, index) => <CapsuleTabs.Tab title={i.name} key={`${index}`}>
                                {
                                    i.list.length > 0 ? i.list.map((p, pIndex) => <Product {...p} />) : <Loading />
                                }
                            </CapsuleTabs.Tab>)}
                        </CapsuleTabs>
                    </Tabs.Tab>
                            */}
          {promotion?.switch && (
            <Tabs.Tab title={promotion?.name || ""} key="promotion">
              <Base url="promotion-list" />
            </Tabs.Tab>
          )}

          <Tabs.Tab title="查询直播价" key="query">
            <QueryBase />
          </Tabs.Tab>
        </Tabs>
      </Sticky>
    </Container>
  );
};

export default Index;

const Container = styled.div`
  background: white;
  height: 100vh;
`;

const Img = styled.img`
  width: 100%;
  object-fit: contain;
`;
const Sticky = styled.div`
  height: 100%;
  position: sticky;
  top: 0;
`;
